/* ═══════════════════════════════════════════════════════════════
   Org Chart V2 — dagre TB auto-layout helper. Ported unchanged from
   the old OrgChart.tsx (`getLayoutedElements`).
   ═══════════════════════════════════════════════════════════════ */

import dagre from 'dagre';
import type { Node, Edge } from '@xyflow/react';
import { NODE_WIDTH, NODE_HEIGHT } from './types';

export function getLayoutedElements<T extends Node>(nodes: T[], edges: Edge[]): T[] {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: 'TB', nodesep: 60, ranksep: 100, marginx: 40, marginy: 40 });

  for (const node of nodes) {
    g.setNode(node.id, { width: NODE_WIDTH, height: NODE_HEIGHT });
  }
  for (const edge of edges) {
    g.setEdge(edge.source, edge.target);
  }

  dagre.layout(g);

  return nodes.map((node) => {
    const pos = g.node(node.id);
    return { ...node, position: { x: pos.x - NODE_WIDTH / 2, y: pos.y - NODE_HEIGHT / 2 } } as T;
  });
}
